import { ErrorHandler } from '@src/shared/ui/components/ErrorHandler';
import { Table as TableComponent } from '@src/shared/ui/components/TableStatic';
import React, { useMemo } from 'react';

import configuration from './includes/configuration.json';

/**
 * Table
 *
 * Data containing sources and record ids for trusted and untrusted values.
 *
 * @param rows
 * @param type
 * @returns {Element}
 * @constructor
 */
export function Table({ rows = [], type = '' }) {
  /**
   * Columns for table.
   */
  const columns = useMemo(() => {
    return configuration?.initialColumns.map((item) => {
      const column = item;

      if (column.Header.includes('Source')) {
        if (type === 'trusted') {
          column.Header = 'Trusted Source';
        } else {
          column.Header = 'Untrusted Source';
        }
      }

      return column;
    });
  }, [type]);

  return (
    <ErrorHandler location="src/widgets/RiskRecords/Attribute/components/Table/Table.jsx">
      <TableComponent
        {...{
          accessor: `eidSearch-attribute-${type}`,
          columns,
          configuration,
          rows,
        }}
      />
    </ErrorHandler>
  );
}
